export const getters = {
    getGradeProduto: state => state.gradeProduto,
    getGradesProduto: state => state.gradesProduto,
    getModalCadastroGradeProduto: state => state.modalCadastroGradeProduto,
    getModalExcluirGradeProduto: state => state.modalExcluirGradeProduto,
    getModalListarGradeProduto: state => state.modalListarGradeProduto,
}

export default {}